import React, { useState } from "react"
import ToggleButton from "react-bootstrap/ToggleButton"
import ToggleButtonGroup from "react-bootstrap/ToggleButtonGroup"
import { ConfigContainer, Popup } from "components"
import { Title, Container, Text, ItemList } from "components/Form"
import { useDispatch, useSelector } from "react-redux"
import { customerAdministration, message, token } from "state_management"
import useT from "utils/hooks/useT"
import { FiCopy } from "react-icons/fi"

import "./index.scss"
import { Button } from "react-bootstrap"

export default function CustomerConfig({ customer, onClose }) {
  const { t } = useT("messages")
  const { t: tc } = useT("common")
  const [name, setName] = useState(customer ? customer.name : "")
  const [statusIsActive, setStatusIsActive] = useState(customer ? customer.active : true)
  const [seatsToBePurchased, setSeatsToBePurchased] = useState(customer ? customer.seatsPurchased : 0)
  const adminId = customer ? customer.adminId : ""
  const id = customer ? customer.id : ""
  const [domains, setDomains] = useState(customer ? customer.domains : [])
  const [showToken, setShowToken] = useState(false)
  const tokenString = useSelector((state) => state.token.token)
  const hasApiToken = customer ? customer.hasApiToken : false;

  const dispatch = useDispatch()

  const handleCopy = () => {
    navigator.clipboard
      .writeText(tokenString)
      .then(() => {
        dispatch(message.success(t("adhoc.copiedToClipboard")))
      })
      .catch(() => {
        dispatch(message.error(t("adhoc.couldNotCopyToClipboard")))
      })
  }

  // Returns true if the provided domain starts with '@'
  const domainStartsWithAt = (domain) => {
    if (!domain || typeof domain !== "string") return false
    return domain.trim().startsWith("@")
  }

  return (
    <ConfigContainer
      title={customer ? tc("editCustomer") : tc("addCustomerTitle")}
      deleteTitle={tc("deleteCustomer")}
      keyWordForAllowedDeletion="DELETE"
      deleteHandler={
        customer &&
        ((allowDeletion) => {
          if (allowDeletion === "DELETE") {
            dispatch(customerAdministration.deleteCustomer(id)).then(() => onClose())
          } else {
            dispatch(message.info(t("adhoc.didNotSpellDeleteProperly")))
          }
        })
      }
      cancelHandler={onClose}
      submitHandler={() => {
        // Prevent saving if any entered domain does not start with '@'
        if (domains && domains.some((d) => !domainStartsWithAt(d))) {
          dispatch(message.error(t("adhoc.domainMustStartWithAt")))
          return
        }

        if (!customer) {
          const newCustomer = {
            name: name,
            domains: domains,
            seatsPurchased: seatsToBePurchased,
            active: statusIsActive,
          }
          dispatch(customerAdministration.addCustomer(newCustomer))
        } else {
          const updatedCustomer = {
            name: name,
            adminId: adminId,
            domains: domains,
            seatsPurchased: seatsToBePurchased,
            active: statusIsActive,
          }

          dispatch(customerAdministration.editCustomer(id, updatedCustomer))
        }
        onClose()
      }}
    >
      {showToken && (
        <Popup
          nonScrollable
          className="tokenPopupContainer"
          onCancel={() => {
            dispatch(token.hideToken()) // Delete the token from redux
            setShowToken(false)
          }}
        >
          <div>
            <h4>{tc("permanentApiToken")}</h4>
            <p>{tc("permanentApiTokenDescription")}</p>
            <Container>
              <Title>{tc("apiToken")}</Title>
              <Title>
                {tokenString}{" "}
                <span title={tc("copyToClipboard")} className="teamconfig-copy-clipboard">
                  <FiCopy onClick={handleCopy} />
                </span>
              </Title>
            </Container>
          </div>
          <Button
            className="close-popup-button"
            variant="primary"
            onClick={() => {
              dispatch(token.hideToken()) // Delete the token from redux
              setShowToken(false)
            }}
          >
            {tc("ok")}
          </Button>
        </Popup>
      )}
      <Container>
        <Title>{tc("customerName")}</Title>
        <Text value={name} required onChange={(e) => setName(e)} />
      </Container>
      <Container>
        <Title>{tc("customerStatus")}</Title>
        <ToggleButtonGroup
          type="radio"
          className="CustomerConfig-toggleButtonGroup"
          name={tc("customerStatus")}
          defaultValue={statusIsActive ? "ACTIVE" : "PASSIVE"}
        >
          <ToggleButton value="ACTIVE" variant="light" onClick={() => setStatusIsActive(true)} id="customeradmin-status-active" className="CustomerConfig-radioButton">
            {tc("active")}
          </ToggleButton>
          <ToggleButton value="PASSIVE" variant="light" onClick={() => setStatusIsActive(false)} id="customeradmin-status-passive" className="CustomerConfig-radioButton">
            {tc("passive")}
          </ToggleButton>
        </ToggleButtonGroup>
      </Container>
      <div className="CustomerConfig-allowedDomains">
        <Container>
          <Title>{tc("allowedDomains")}</Title>
          <ItemList value={domains} onChange={setDomains} itemName={tc("domain")} />
        </Container>
      </div>
      <Container>
        <Title>{tc("seatsPurchased")}</Title>
        <Text value={seatsToBePurchased} onChange={(e) => setSeatsToBePurchased(e)} />
      </Container>

      {customer && (
        <Container>
          <Title>{tc("customerApiKey")}</Title>
          {hasApiToken ? (
            <Button
              variant="danger"
              style={{ marginLeft: "1rem", borderRadius: "0.25rem"}}
              onClick={() => {
                dispatch(customerAdministration.setHasAPIToken(id, false))
                dispatch(token.deleteCompanyToken(id))
              }}
            >
              {tc("deleteApiKey")}
            </Button>
          ) : (
            <Button
              variant="success"
              style={{ marginLeft: "1rem", borderRadius: "0.25rem"}}
              onClick={() => {
                dispatch(customerAdministration.setHasAPIToken(id, true))
                dispatch(token.createCompanyToken(id))
                setShowToken(true)
              }}
            >
              {tc("createApiKey")}
            </Button>
            )
          }
        </Container>
      )}
    </ConfigContainer>
  )
}
